module.exports = __webpack_public_path__ + "static/media/CaviarDreams_Bold.65ab651c.ttf";